<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>应收</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.code_like" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.status">
                <vDropdown
                    model_key="status"
                    model_name="请选择状态"
                    select_value="value"
                    request_uri="dropdownKdStatus"
                    :model_value_default="queryParams['status']"
                    @onDropChange="onDropChange"
                    ref="status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.partner_rid">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.product_rid">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item" v-if="postList.supplier_rid">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入供方搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-if="postList.demander_rid">
                <vSearchSelect
                    model_key="demander_rid"
                    model_name="请输入需方搜索"
                    request_uri="searchAccounts"
                    default_option_key="demander_option"
                    :default_option="queryParams['demander_option']"
                    @onDropChange="onDropChange"
                    ref="demander_rid_ref"
                ></vSearchSelect>
            </div>

            <div class="main_header_item" v-show="postList.ppa_code">
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.person1_rid">
                <vDropdown
                    model_key="person1_rid"
                    model_name="请选择业务员1"
                    :model_value_default="queryParams['person1_rid']"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="person1_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.person2_rid">
                <vDropdown
                    model_key="person2_rid"
                    model_name="请选择业务员2"
                    :model_value_default="queryParams['person2_rid']"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="person2_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.date">
                <el-date-picker
                    v-model="queryParams['date']"
                    type="daterange"
                    start-placeholder="应收日期"
                    end-placeholder="应收日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['business_date']"
                    type="daterange"
                    start-placeholder="业务日期"
                    end-placeholder="业务日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="promotion_type_empty"
                    model_name="推广类型为空"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['promotion_type_empty']"
                    @onDropChange="onDropChange"
                    ref="promotion_type_empty_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="is_adjust"
                    model_name="是否调整单"
                    select_value="value"
                    request_uri="yesOrNo"
                    :model_value_default="queryParams['is_adjust']"
                    @onDropChange="onDropChange"
                    ref="is_adjust_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.performance_unit_name"
                    placeholder="请输入绩效单元"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="syncTransaction('increment')" :loading="btnLoading">同步金蝶</el-button>
                <el-button size="small" plain @click="flushLoss()" :loading="btnLoading">刷新损失信息</el-button>
                <el-button size="small" plain @click="deleteAdjustment()" :loading="btnLoading">删除调整单</el-button>
                <el-button size="small" plain @click="flushALK()" :loading="btnLoading">刷新A库调整</el-button>
                <el-button size="small" plain @click="flushClearing()" :loading="btnLoading">刷新清账信息</el-button>
                <el-button size="small" plain @click="syncClearingToSf()" :loading="btnLoading">应收清账同步至SF</el-button>
                <el-button size="small" plain @click="flushPerformanceUnitCode()" :loading="btnLoading">刷新绩效单元</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="receivable" :queryParams="queryParams" :display_insert="false" :display_delete="false"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>

            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px">最近一次执行记录：</span>
                </div>
                <div class="flex" v-for="(item, index) in taskQueueMessage" :key="index">
                    <span style="color: red; font-size: 13px">
                        {{ item }}
                    </span>
                </div>
                <div class="flex" v-if="taskQueueMessage.length == 0">
                    <span style="color: red; font-size: 13px">暂无执行记录</span>
                </div>
            </div>

            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="receivable"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div
                                v-if="
                                    in_array(item.prop, [
                                        'code',
                                        'supplier',
                                        'demander',
                                        'partner',
                                        'product',
                                        'partner_current',
                                        'person1',
                                        'person2',
                                        'ppa_code'
                                    ])
                                "
                            >
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="绩效分配" placement="top-start">
                            <i class="el-icon-s-operation" @click="performanceAssignment(scope.row.rid)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'receivableComponent',
    data() {
        return {
            is_show_help: false,
            draggable: {
                data_name: 'receivable'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            taskQueueMessage: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initTaskQueueMessage();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        initTaskQueueMessage() {
            this.$api['taskQueueMessage']({
                code: ['sync_k3_receivable', 'sync_sf_transaction_line_clearing']
            })
                .then((res) => {
                    if (res.code == 0) {
                        // 从未执行过的任务后端返回空串，过滤掉，否则会渲染成空白行
                        this.taskQueueMessage = (res.data || []).filter((v) => v);
                    }
                })
                .catch((error) => {
                    this.taskQueueMessage = [];
                });
        },
        // 只把应收清账推到SF，不重算。上游是「刷新清账信息」，与各类重算任务互斥。
        // 不加确认框：任务是幂等的——与「重算消化行」里那次同步共用同一把 REFRESH_LOCK_KEY，
        // 且推送走内容哈希差量，重复触发会优雅跳过，误点的代价只是多等几分钟。
        syncClearingToSf() {
            this.btnLoading = true;
            // 公用绩效重算接口，type=5 为应收清账同步至SF
            this.$api['performanceUnitRecalculate']({ type: 5 })
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: res.data,
                            type: 'success'
                        });
                        this.reload();
                    }
                    this.btnLoading = false;
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['code']) && row.rid) {
                this.$router.push({
                    path: '/receivableDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'supplier' && row.supplier_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.supplier_rid
                    }
                });
            } else if (prop == 'demander' && row.demander_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.demander_rid
                    }
                });
            } else if (prop == 'partner' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (prop == 'product' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (prop == 'partner_current' && row.partner_current_rid != '') {
                this.$router.push({
                    path: '/partnerCurrentDetail',
                    query: {
                        id: row.partner_current_rid
                    }
                });
            } else if (prop == 'person1' && row.person1_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.person1_rid
                    }
                });
            } else if (prop == 'person2' && row.person2_rid != '') {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.person2_rid
                    }
                });
            } else if (prop == 'ppa_code' && row.ppa_rid != '') {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: row.ppa_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('receivable_params', JSON.stringify(this.queryParams));
            }
        },
        syncTransaction(type) {
            this.$confirm('您确定要手动同步吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['receivableSyncFromK3']({
                        type: type
                    })
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushLoss(type) {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['receivableFlushLoss']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        deleteAdjustment() {
            this.$confirm('您确定要删除吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['deleteAdjustment']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushALK() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushALK']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushClearing() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushClearing']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        flushPerformanceUnitCode() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['flushPerformanceUnitCode']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },

        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('receivable_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('receivable', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).receivable;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'receivableLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.getList();
        },
        performanceAssignment(rid) {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'insert',
                    object_type_code: 2,
                    object_rid: rid
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'receivableEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>